import { PermissaoTokenDTO } from "@/core/domain/dto/seguranca/acesso/oauth/permissao-token.dto";
import { ModuloDTO } from "@/core/domain/dto/privado/aplicacao/modulo/modulo.dto";
import { UsuarioTokenDTO } from "@/core/domain/dto/seguranca/acesso/oauth/usuario-token.dto";
import {
    buildModulosFromPermissoesOnly,
    mergeModulosAncestorsFromFlatTree,
} from "@/core/utils/menu/build-user-modulos.util";
import { MenuItem } from "primeng/api";
import { buildMenuItemsFromModulos } from "./build-menu-items.util";

export function getPermissoesDoPerfilSelecionado(user?: UsuarioTokenDTO): Array<PermissaoTokenDTO> {
    return user?.perfis?.[0]?.permissoes ?? [];
}

export function buildMenuItemsFromPermissoes(
    permissoes: Array<PermissaoTokenDTO>,
    menuModulosFlat?: Array<ModuloDTO>,
): Array<MenuItem> {
    let modulos = buildModulosFromPermissoesOnly(permissoes);

    if (menuModulosFlat?.length) {
        modulos = mergeModulosAncestorsFromFlatTree(modulos, menuModulosFlat);
        return buildMenuItemsFromModulos(modulos, { orderReference: menuModulosFlat });
    }

    return buildMenuItemsFromModulos(modulos, { sortByIndex: true });
}